import addPanelDataConsts from '#packages/addPanelDataConsts';
import membersWelcome from './membersWelcome';

const membersWelcomeSection = {
  type: addPanelDataConsts.SECTIONS_TYPES.GENERAL,
  hide: false,
  title: 'add_section_label_memberarea',
  showSectionHeader: true,
  props: {
    class: 'no-space-before-section invisible-header',
    template: membersWelcome,
  },
  help: {
    hide: false,
    text: 'add_section_label_memberarea_tooltip_description',
  },
};

export default {
  getCategorySections() {
    return {
      membersWelcomeSection,
    };
  },
};
